import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M17.869 5.333c-2.65 0-5.396.106-8.24.316a4.278 4.278 0 0 0-3.962 4.266v9.474a4.278 4.278 0 0 0 4.277 4.278h15.704a4.278 4.278 0 0 0 4.263-3.924c.133-1.606.2-3.354.2-5.243 0-1.847-.064-3.495-.191-4.947a4.278 4.278 0 0 0-3.915-3.889 100.26 100.26 0 0 0-8.136-.33ZM24 26.723a.611.611 0 0 0-.611-.612H8.722a5.5 5.5 0 0 1-5.5-5.5v-8.556a.611.611 0 0 0-1.222 0v8.556a6.722 6.722 0 0 0 6.722 6.722H23.39a.611.611 0 0 0 .611-.61Z",
      clipRule: "evenodd"
    }
  )
);
var SvgShareScreenFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ShareScreenFilled_default = SvgShareScreenFilled;

export { ShareScreenFilled_default as default };
